<template>
  <div class="sub-wizard">
    <ul v-if="type === 'usernew'" class="nav-wizard flex">
      <li class="wizard-list list" :class="[{active: 0 == activeIndex}, {passed: 0 < activeIndex}]">
        お客さま<br class="-pcnone">情報
      </li>
      <li class="dotted-box dottedlist" :class="[{active: 0 == activeIndex}, {passed: 0 < activeIndex}]">
        <span class="dotted"></span>
      </li>
      <li class="wizard-list list" :class="[{active: 1 == activeIndex}, {passed: 1 < activeIndex}]">
        お勤め先
      </li>
      <li class="dotted-box dottedlist" :class="[{active: 1 == activeIndex}, {passed: 1 < activeIndex}]">
        <span class="dotted"></span>
      </li>
      <li class="wizard-list list" :class="[{active: 2 == activeIndex}, {passed: 2 < activeIndex}]" >
        お借り入れ<br class="-pcnone">状況
      </li>
    </ul>
    <ul v-if="type === 'upload'" class="nav-wizard flex">
      <li class="wizard-list list" :class="[{active: 0 == activeIndex}, {passed: 0 < activeIndex}]">
        <span class="-spnone">書類の<br class="-pcnone">ご選択</span>
        <span class="-pcnone">ご選択</span>
      </li>
      <li class="dotted-box dottedlist" :class="[{active: 0 == activeIndex}, {passed: 0 < activeIndex}]">
        <span class="dotted"></span>
      </li>
      <li class="wizard-list list" :class="[{active: 1 == activeIndex}, {passed: 1 < activeIndex}]">
        <span class="-spnone">ファイルのご選択</span><span class="-pcnone">撮影する</span>
      </li>
      <li class="dotted-box dottedlist" :class="[{active: 1 == activeIndex}, {passed: 1 < activeIndex}]">
        <span class="dotted"></span>
      </li>
      <li class="wizard-list list" :class="[{active: 2 == activeIndex}, {passed: 2 < activeIndex}]" >
        ご確認
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'sub-wizard',
  props: {
    activeIndex: {type: Number},
    type: {type: String}
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .sub-wizard {
    max-width: 740px;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    >.nav-wizard {
      text-align: center;
      font-size: 12px;
      @include mq-up(md) {
        font-size: 16px;
      }
      &.flex {
        align-items: unset;
      }
      >.wizard-list {
        display: inline-block;
        border: 1px solid $secondary;
        border-radius: 10px;
        padding-top: 14px;
        padding-bottom: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.list {
          width: 26%;
          float: left;
          @include mq-up(md) {
            max-width: 160px;
            width: 100%;
          }
        }
        &.passed {
          color: #aaa;
        }
        &.active {
          background-color: $success;
          border: 1px solid $primary;
        }
      }
      >.dotted-box {
        padding-top: 30px;
        padding-bottom: 30px;
        @include mq-up(md) {
          padding-top: 21.5px;
          padding-bottom: 21.5px;
        }
        &.dottedlist {
          width: 8%;
          float: left;
          @include mq-up(md) {
            width: 95px;
          }
        }
        >.dotted {
          background-image: linear-gradient(to right, $primary, $primary 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
          background-size: 10px 2px;
          height: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &.passed {
          >.dotted {
            background-image: linear-gradient(to right, $secondary, $secondary 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wizard/SubWizard.vue